import PlentyShopLTSModern from "./plentyShopLTSModern";

document.addEventListener("DOMContentLoaded", () =>
{
    new PlentyShopLTSModern();
});
